  // export const apiUrl =  "http://localhost:8080/api/";
  // export const publicApiUrl =  "http://localhost:8080/public/";
export const apiUrl = "https://nutrim.herokuapp.com/api/";
export const publicApiUrl = "https://nutrim.herokuapp.com/public/";